/**
 * WooCommerce - Main Entry Point
 * Imports and initializes all WooCommerce functionality
 */

import { initializeCartHandlers } from './woocommerce/cart/handlers'
import { initializeFeatureProducts } from './woocommerce/features/handlers'
import { initializeQuoteDrawer } from './woocommerce/quote/drawer'
import { showNotice, ajaxReplace, initializeDeleteDevice, initializeFeaturesCoupon } from './woocommerce/utils'

// ===================================================================
// Initialize on DOM Ready
// ===================================================================

document.addEventListener('DOMContentLoaded', () => {
  // Initialize cart functionality (add to cart, drawer, quantity)
  initializeCartHandlers()

  // Initialize feature products (device selection)
  initializeFeatureProducts()

  // Initialize the Get a Quote drawer (security product pages)
  initializeQuoteDrawer()

  // Initialize delete device functionality
  initializeDeleteDevice()

  // Initialize features coupon functionality
  initializeFeaturesCoupon()


  const checkLabels = () => {
    const freeShippingInput = document.querySelector('input[value*="free_shipping:"]');
    const freeShippingCarrier = document.querySelector('p.free-shipping-carrier');

    // Hide UPS® Ground (wf_shipping_ups:03) whenever UPS Ground Saver® (wf_shipping_ups:93) is available
    const upsGroundSaverInput = document.querySelector('input[value*="wf_shipping_ups:93"]');
    const upsGroundOnlyInput = document.querySelector('input[value*="wf_shipping_ups:03"]');
    if (upsGroundSaverInput && upsGroundOnlyInput) {
      const upsGroundOnlyLabel = document.querySelector(`label[for="${upsGroundOnlyInput.id}"]`);
      if (upsGroundOnlyLabel) {
        upsGroundOnlyLabel.style.display = 'none';
        // If the hidden option was selected, move the selection to Ground Saver
        if (upsGroundOnlyInput.checked) {
          upsGroundSaverInput.click();
        }
      }
    }

    if (freeShippingInput) {

      const smartPostInput = document.querySelector('input[value*="wf_fedex_woocommerce_shipping:SMART_POST"]');
      const groundInput = document.querySelector('input[value*="wf_fedex_woocommerce_shipping:FEDEX_GROUND"]');
      const upsGroundInput = document.querySelector('input[value*="wf_shipping_ups:03"]');

      if (smartPostInput) {
        const smartPostLabel = document.querySelector(`label[for="${smartPostInput.id}"]`);
        if (smartPostLabel) {
          smartPostLabel.remove();
        }
      }
      if (groundInput) {
        const groundLabel = document.querySelector(`label[for="${groundInput.id}"]`);
        if (groundLabel) {
          groundLabel.remove();
        }
      }
      if (upsGroundInput) {
        const upsGroundLabel = document.querySelector(`label[for="${upsGroundInput.id}"]`);
        if (upsGroundLabel) {
          upsGroundLabel.remove();
        }
      }

      // Show free shipping carrier element
      if (freeShippingCarrier) {
        freeShippingCarrier.style.display = '';
      }
    } else {
      // Hide free shipping carrier element when free shipping is not available
      if (freeShippingCarrier) {
        freeShippingCarrier.style.display = 'none';
      }
    }
  };

  const initObserver = (target) => {
    const observer = new MutationObserver(() => checkLabels());
    observer.observe(target, { childList: true, subtree: true });
    checkLabels();
  };

  const shippingFieldset = document.querySelector("#shipping-option") ||
    document.querySelector(".wc-block-checkout__shipping-option") ||
    document.body;

  initObserver(shippingFieldset);



})

// ===================================================================
// Device Registration Form Handler
// (Separate from cart - handles device registration on product pages)
// ===================================================================

document.addEventListener('submit', async function (e) {
  const registerForm = e.target.closest('form[name=device-register]')
  if (!registerForm) return

  e.preventDefault()

  const submitButton = registerForm.querySelector('button[type=submit]')
  const loading = registerForm.querySelector('.loading')
  const productDetailsForm = document.querySelector('.product-details .add-to-cart')

  submitButton.classList.add('is-loading')
  submitButton.disabled = true
  loading?.classList.add('active')

  const registerFormData = new FormData(registerForm)
  registerFormData.append('action', 'device_add')
  registerFormData.append('security', window.garrett?.nonce)

  try {
    const response = await fetch(window.garrett?.ajaxurl, {
      method: 'POST',
      credentials: 'same-origin',
      body: registerFormData,
    })

    if (response.ok) {
      const responseData = await response.json()

      const messageType = responseData.success ? 'success' : 'error'
      showNotice(responseData.message, messageType)

      if (responseData.success && productDetailsForm) {
        await ajaxReplace('.product-details .add-to-cart')
      }
    } else {
      console.error('Error in response')
    }
  } catch (error) {
    console.error('Error in fetch request:', error)
  }

  submitButton.classList.remove('is-loading')
  submitButton.disabled = false
  loading?.classList.remove('active')
  registerForm.reset()
})
